import React, { useEffect, useState } from 'react';
import { get } from 'lodash';
import { Modal, Row, Col } from 'react-bootstrap';
import { TerraformService } from '../TerraformService';
import { IPromise } from 'angular';
import { ConsoleView } from '../../common/consoleView';
import { Spinner } from '@spinnaker/core';
import * as copy from 'copy-to-clipboard';

// Styles
import '../../../styles/terraform/console-output-modal.scss';
interface ITerraformConsoleOutputModalProps {
  jobStatus: string;
  jobId: string;
  linkName: string;
  modalTitle: string;
}

const streamToAnsiMap = {
  'stdout': '\x1b[32m',
  'stderr': '\x1b[31m',
};

const TerraformConsoleOutputModal = ({ jobStatus, jobId, linkName, modalTitle }: ITerraformConsoleOutputModalProps) => {
  const [loading, updateLoading] = useState<boolean>(true);
  const [logsCombined, setLogsCombined] = useState<string>('');
  const [modalVisible, setModalVisible] = useState<boolean>(false);
  const [timerID, setTimerID] = useState<any>(null);
  const [copyState, setCopyState] = useState<string>('');
  const [processingLogs, setProcessingLogs] = useState<boolean>(true);
  const scrollToBottom = () => {
    const console = document.getElementById('console-output');
    console.scrollTop = console.scrollHeight;
  }
  const copyToClipboard = () => {
    copy(logsCombined);
    setCopyState('success');
  }
  const withAnsiColor = (key: string, value: string): string => {
    const streamType = key.split('_')[1];
    return streamToAnsiMap[streamType] + value;
  }
  const makeCombinedLogs = (logs: object): string => {
    return Object.entries(logs)
          .filter(([_, value]) => value !== '')
          .map(([key, value]) => withAnsiColor(key, value as string))
          .join('\n');
  }
  const getAndProcessLogs = (): IPromise<any> => {
    return TerraformService.getLogs(jobId).then((logs) => {
      const combinedLogs = get(logs, 'combined', makeCombinedLogs(logs));
      setLogsCombined(combinedLogs);
      updateLoading(false);
    });
  }
  const toggle = () => {
    setModalVisible(!modalVisible);
  };
  const logsTimer = () => setTimeout(() => getAndProcessLogs(), 2000);
  useEffect(() => {
    if (modalVisible) {
      if (jobStatus !== 'COMPLETE') {
        setTimerID(logsTimer());
      } else {
        clearTimeout(timerID);
        getAndProcessLogs()
        setProcessingLogs(false);
      }
    }
  }, [modalVisible, jobStatus])

  return (
    <>
      <a key="modal-link" onClick={toggle} className="clickable">
        {linkName}
      </a>
      <Modal bsSize="lg" key="modal" show={modalVisible} onHide={toggle} dialogClassName="flex-fill modal-fullscreen console-output-modal">
        <Modal.Header closeButton={true}>
          <h3>{modalTitle}</h3>
        </Modal.Header>
        <Modal.Body className="flex-fill">
          { loading && (
            <div className="horizontal middle center" style={{ marginBottom: '250px', height: '150px' }}>
              <Spinner size="medium"/>
            </div>
          )}
          { !loading && (
            <div style={{height: '100%'}}>
              <Row style={{height: '100%'}}>
                <Col sm={12} style={{height: '100%', position: 'relative', overflowY: 'scroll'}} id="console-output">
                  { logsCombined && (
                    <>
                      <div className="console-view-actions">
                        <button className="console-view-actions__btn" onClick={copyToClipboard}>
                          <span className={`glyphicon glyphicon-copy ${copyState}`} />
                        </button>
                        <button className="console-view-actions__btn" onClick={scrollToBottom}>
                          <span className="glyphicon glyphicon-arrow-down" />
                        </button>
                      </div>
                      <div style={{ marginTop: '-39px', height: '100px' }}>
                        {processingLogs && <span className="spinner"/>}
                        <ConsoleView input={logsCombined} />
                      </div>
                    </>
                  )}
                </Col>
              </Row>
            </div>
          )}
        </Modal.Body>
      </Modal>
    </>
  );

};

export default TerraformConsoleOutputModal;
